import React from "react";
import Nav from "../Nav/Nav.js";
import perfil from "../../img/image-perfil.jpg";

import "../About/About.css";

function About() {
  return (
    <> 
      <Nav />
      <main className="main-about">
        <section className="box">
          <div className="header">
            <p>Karla Guzmán.jpg</p>
            <p>X</p> 
          </div>
          <img alt="imagen de perfil" className="perfil-image" src={perfil} />
        </section>

        <section className="info">
          <h1>Karla Guzmán</h1>
          <p>
            Actualmente soy estudiante de octavo semestre de la carrera en Informática y de manera autodidacta
            estudio Frontend, me siento cómoda trabajando con HTML, CSS, JS, SQL
            y estoy aprendiendo React, busco una oportunidad en una empresa donde pueda desempeñar mis conocimientos 
            y adquirir nuevos junto a un equipo de trabajo. Me gusta dibujar en pixel art, arte en
            3D, ver películas y las <span>ranitas</span> obvio.
          </p>
          <div className="skills">
            <h2 className="skills">Skills</h2>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
              <path d="M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z" />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path d="M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z" />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path d="M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z" />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path d="M448 80V128C448 172.2 347.7 208 224 208C100.3 208 0 172.2 0 128V80C0 35.82 100.3 0 224 0C347.7 0 448 35.82 448 80zM393.2 214.7C413.1 207.3 433.1 197.8 448 186.1V288C448 332.2 347.7 368 224 368C100.3 368 0 332.2 0 288V186.1C14.93 197.8 34.02 207.3 54.85 214.7C99.66 230.7 159.5 240 224 240C288.5 240 348.3 230.7 393.2 214.7V214.7zM54.85 374.7C99.66 390.7 159.5 400 224 400C288.5 400 348.3 390.7 393.2 374.7C413.1 367.3 433.1 357.8 448 346.1V432C448 476.2 347.7 512 224 512C100.3 512 0 476.2 0 432V346.1C14.93 357.8 34.02 367.3 54.85 374.7z" />
            </svg>
          </div>
        </section>
      </main>
    </>
  );
}

export default About;
